export type DesktopSidebar = "assets" | "inspector";

export type DesktopSidebarPreference = Record<DesktopSidebar, boolean>;

export const desktopSidebarPreferenceKey = "seedance.canvas.desktop-sidebars.v1";

const defaultPreference: DesktopSidebarPreference = {
  assets: true,
  inspector: true
};

export function readDesktopSidebarPreference(storage: Storage | undefined): DesktopSidebarPreference {
  if (!storage) return { ...defaultPreference };
  try {
    const value: unknown = JSON.parse(storage.getItem(desktopSidebarPreferenceKey) ?? "null");
    if (
      value !== null &&
      typeof value === "object" &&
      typeof (value as Partial<DesktopSidebarPreference>).assets === "boolean" &&
      typeof (value as Partial<DesktopSidebarPreference>).inspector === "boolean"
    ) {
      return {
        assets: (value as DesktopSidebarPreference).assets,
        inspector: (value as DesktopSidebarPreference).inspector
      };
    }
  } catch {
    // Browsing controls must remain usable when local storage is unavailable.
  }
  return { ...defaultPreference };
}

export function writeDesktopSidebarPreference(
  storage: Storage | undefined,
  preference: DesktopSidebarPreference
): void {
  try {
    storage?.setItem(desktopSidebarPreferenceKey, JSON.stringify(preference));
  } catch {
    // This preference is local-only and must never block canvas interaction.
  }
}
